/** Paragraph text styles (Apple Notes–style) + restricted heading accents. */

import { selectionInsideBlockquote } from './pathstone_blockquote_content.js';

export const POST_EDITOR_PARAGRAPH_STYLES = ['body', 'caption', 'heading', 'subheading'];

/** Toolbar + color rules treat unset paragraph style the same as Body. */
export function effectivePostParagraphStyle(postTextStyle) {
  return postTextStyle || 'body';
}

/** Swatch preview uses design tokens from `variables.scss` :root. */
export const POST_EDITOR_HEADING_ACCENTS = [
  { id: 'black', label: 'Black', cssVar: 'var(--ps-black)' },
  { id: 'gray-07', label: 'Gray 07', cssVar: 'var(--ps-gray-07)' },
  { id: 'plum', label: 'Plum', cssVar: 'var(--ps-plum)' },
  { id: 'red', label: 'Red', cssVar: 'var(--ps-red)' },
  { id: 'gold', label: 'Gold', cssVar: 'var(--ps-gold)' },
  { id: 'moss', label: 'Moss', cssVar: 'var(--ps-moss)' },
];

export function paragraphStyleLocksFontFamily(style) {
  return style === 'heading' || style === 'subheading' || style === 'caption';
}

/** True when the selection touches a Heading or Subheading paragraph. */
export function selectionInHeadingOrSubheadingParagraph(state) {
  const { from, to } = state.selection;
  let locked = false;
  state.doc.nodesBetween(from, to, (node) => {
    if (node.type.name !== 'paragraph') return;
    const style = node.attrs.postTextStyle;
    if (style === 'heading' || style === 'subheading') {
      locked = true;
      return false;
    }
  });
  return locked;
}

export function isPostEditorListLockedForParagraphStyle(postTextStyle) {
  return postTextStyle === 'heading' || postTextStyle === 'subheading' || postTextStyle === 'caption';
}

/** True when inline links must not be applied (heading, subheading, or pull quote). */
export function selectionInRestrictedInlineLinkContext(state) {
  if (selectionInsideBlockquote(state)) return true;
  return selectionInHeadingOrSubheadingParagraph(state);
}

/** Toolbar: disable the link control in the same contexts as {@link selectionInRestrictedInlineLinkContext}. */
export function isPostEditorInlineLinkLocked(toolbarState) {
  return (
    !!toolbarState.blockquote ||
    toolbarState.postTextStyle === 'heading' ||
    toolbarState.postTextStyle === 'subheading'
  );
}
